module.exports = __webpack_public_path__ + "static/media/brands_block.a0d982f4.png";